import { Language } from "../types";

export interface LeagueTranslation {
  league_id: number;
  names: Record<Language | string, string>;
}

export interface LeaguePolicy {
  league_id: number;
  ucl: number[]; // Champions League / ACLE positions
  uel: number[]; // Europa League / ACL2 positions
  uecl: number[]; // Conference League positions
  rel_po: number[]; // Relegation Play-off positions
  rel: number[]; // Direct Relegation positions
}

export const LEAGUE_POLICIES: LeaguePolicy[] = [
  { league_id: 39, ucl: [1, 2, 3, 4], uel: [5], uecl: [], rel_po: [], rel: [18, 19, 20] }, // Premier League
  { league_id: 140, ucl: [1, 2, 3, 4], uel: [5, 6], uecl: [], rel_po: [], rel: [18, 19, 20] }, // La Liga
  { league_id: 135, ucl: [1, 2, 3, 4], uel: [5, 6], uecl: [], rel_po: [], rel: [18, 19, 20] }, // Serie A
  { league_id: 78, ucl: [1, 2, 3, 4], uel: [5], uecl: [6], rel_po: [16], rel: [17, 18] }, // Bundesliga
  { league_id: 61, ucl: [1, 2, 3], uel: [4], uecl: [5], rel_po: [16], rel: [17, 18] }, // Ligue 1
  { league_id: 88, ucl: [1, 2], uel: [3], uecl: [4], rel_po: [5, 6, 7, 8], rel: [17, 18] }, // Eredivisie
  { league_id: 94, ucl: [1, 2], uel: [3], uecl: [], rel_po: [16], rel: [17, 18] }, // Primeira Liga
  { league_id: 292, ucl: [1], uel: [2, 3], uecl: [], rel_po: [10, 11], rel: [12] }, // K League 1 (UCL=ACLE, UEL=ACL2)
  { league_id: 98, ucl: [1, 2, 3], uel: [], uecl: [], rel_po: [], rel: [18, 19, 20] }, // J1 League
];

export const LEAGUE_TRANSLATIONS: LeagueTranslation[] = [
    // ===== Big 5 =====
  { league_id: 39,
    names: {
      en: "Premier League",
      ko: "프리미어리그",
      ja: "プレミアリーグ",
      es: "Premier League",
      fr: "Premier League",
    },
  },
  {
    league_id: 140,
    names: {
      en: "La Liga",
      ko: "라리가",
      ja: "ラ・リー가",
      es: "LaLiga",
      fr: "LaLiga",
    },
  },
  {
    league_id: 135,
    names: {
      en: "Serie A",
      ko: "세리에 A",
      ja: "セリエA",
      es: "Serie A",
      fr: "Série A",
    },
  },
  {
    league_id: 78,
    names: {
      en: "Bundesliga",
      ko: "분데스리가",
      ja: "ブンデスリーガ",
      es: "Bundesliga",
      fr: "Bundesliga",
    },
  },
  {
    league_id: 61,
    names: {
      en: "Ligue 1",
      ko: "리그 1",
      ja: "リーグ・アン",
      es: "Ligue 1",
      fr: "Ligue 1",
    },
  },
  // ===== Big 5 (2nd tier) =====
  { league_id: 40, names: { en: "Championship", ko: "잉글랜드 챔피언십", ja: "チャンピオンシップ", es: "Championship", fr: "Championship" } },
  { league_id: 141, names: { en: "La Liga 2", ko: "라리가 2", ja: "ラ・リーガ2", es: "LaLiga 2", fr: "LaLiga 2" } },
  { league_id: 136, names: { en: "Serie B", ko: "세리에 B", ja: "セリエB", es: "Serie B", fr: "Serie B" } },
  { league_id: 79, names: { en: "2. Bundesliga", ko: "2부 분데스리가", ja: "2.ブンデスリーガ", es: "2. Bundesliga", fr: "2. Bundesliga" } },
  { league_id: 62, names: { en: "Ligue 2", ko: "리그 2", ja: "リーグ・ドゥ", es: "Ligue 2", fr: "Ligue 2" } },

  // ===== UEFA Club =====
  { league_id: 2, names: { en: "UEFA Champions League", ko: "UEFA 챔피언스리그", ja: "UEFAチャンピオンズリーグ", es: "UEFA Champions League", fr: "Ligue des champions" } },
  { league_id: 3, names: { en: "UEFA Europa League", ko: "UEFA 유로파리그", ja: "UEFAヨーロッパリーグ", es: "UEFA Europa League", fr: "Ligue Europa" } },
  { league_id: 848, names: { en: "UEFA Europa Conference League", ko: "UEFA 컨퍼런스리그", ja: "UEFAカンファレンスリーグ", es: "UEFA Conference League", fr: "Ligue Europa Conférence" } },
  { league_id: 531, names: { en: "UEFA Super Cup", ko: "UEFA 슈퍼컵", ja: "UEFAスーパーカップ", es: "Supercopa de la UEFA", fr: "Supercoupe de l’UEFA" } },

  // ===== Europe (Top Leagues) =====
  { league_id: 88, names: { en: "Eredivisie", ko: "에레디비시", ja: "エールディヴィジ", es: "Eredivisie", fr: "Eredivisie" } },
  { league_id: 94, names: { en: "Primeira Liga", ko: "프리메이라 리가", ja: "プリメイラ・リーガ", es: "Primeira Liga", fr: "Primeira Liga" } },
  { league_id: 179, names: { en: "Scottish Premiership", ko: "스코티시 프리미어십", ja: "スコティッシュ・プレミアシップ", es: "Premiership escocesa", fr: "Premiership écossaise" } },
  { league_id: 203, names: { en: "Super Lig", ko: "쉬페르리그", ja: "スュペル・リグ", es: "Süper Lig", fr: "Süper Lig" } },
  { league_id: 218, names: { en: "Russian Premier League", ko: "러시아 프리미어리그", ja: "ロシア・プレミアリーグ", es: "Liga Premier rusa", fr: "Première Ligue russe" } },
  { league_id: 119, names: { en: "Danish Superliga", ko: "덴마크 수페르리가", ja: "デンマーク・スーパーリーガ", es: "Superliga danesa", fr: "Superliga danoise" } },
  { league_id: 113, names: { en: "Allsvenskan", ko: "알스벤스칸", ja: "アルスヴェンスカン", es: "Allsvenskan", fr: "Allsvenskan" } },
  { league_id: 244, names: { en: "Belgian Pro League", ko: "벨기에 프로리그", ja: "ベルギー・プロリーグ", es: "Pro League belga", fr: "Pro League belge" } },
  { league_id: 207, names: { en: "Swiss Super League", ko: "스위스 슈퍼리그", ja: "スイス・スーパーリーグ", es: "Superliga suiza", fr: "Super League suisse" } },
  { league_id: 172, names: { en: "Austrian Bundesliga", ko: "오스트리아 분데스리가", ja: "オーストリア・ブンデスリーガ", es: "Bundesliga austríaca", fr: "Bundesliga autrichienne" } },
  { league_id: 197, names: { en: "Greek Super League", ko: "그리스 수페르리가", ja: "ギリシャ・スーパーリーグ", es: "Superliga griega", fr: "Super League grecque" } },
  { league_id: 210, names: { en: "Ukrainian Premier League", ko: "우크라이나 프리미어리그", ja: "ウクライナ・プレミアリーグ", es: "Liga Premier ucraniana", fr: "Première Ligue ukrainienne" } },

  // ===== Americas =====
  { league_id: 253, names: { en: "Major League Soccer", ko: "메이저리그 사커", ja: "メジャーリーグサッカー", es: "MLS", fr: "MLS" } },
  { league_id: 16, names: { en: "CONCACAF Champions League", ko: "CONCACAF 챔피언스리그", ja: "CONCACAFチャンピオンズリーグ", es: "Liga de Campeones de la CONCACAF", fr: "Ligue des champions de la CONCACAF" } },
  { league_id: 242, names: { en: "Liga MX", ko: "리가 MX", ja: "リーガMX", es: "Liga MX", fr: "Liga MX" } },
  { league_id: 71, names: { en: "Brasileirão", ko: "브라질 세리에 A", ja: "ブラジル・セリエA", es: "Brasileirão", fr: "Brasileirão" } },
  { league_id: 128, names: { en: "Argentine Primera División", ko: "아르헨티나 프리메라", ja: "アルゼンチン 1부", es: "Primera División", fr: "Primera División" } },
  { league_id: 265, names: { en: "Chilean Primera División", ko: "칠레 프리메라", ja: "チリ 1부", es: "Primera División de Chile", fr: "Primera División chilienne" } },
  { league_id: 268, names: { en: "Colombian Primera A", ko: "콜롬비아 프리메라 A", ja: "コロンビア 1部", es: "Primera A", fr: "Primera A" } },

  // ===== Asia =====
  { league_id: 292, names: { en: "K League 1", ko: "K리그1", ja: "Kリーグ1", es: "K League 1", fr: "K League 1" } },
  { league_id: 293, names: { en: "K League 2", ko: "K리그2", ja: "Kリーグ2", es: "K League 2", fr: "K League 2" } },
  { league_id: 98, names: { en: "J1 League", ko: "J리그", ja: "J1リーグ", es: "J1 League", fr: "J1 League" } },
  { league_id: 169, names: { en: "Saudi Pro League", ko: "사우디 프로리그", ja: "サウジ・プロリーグ", es: "Saudi Pro League", fr: "Saudi Pro League" } },
  { league_id: 161, names: { en: "Chinese Super League", ko: "중국 슈퍼리그", ja: "中国超級リーグ", es: "Superliga de China", fr: "Super League chinoise" } },
  { league_id: 296, names: { en: "Thai League 1", ko: "태국 리그 1", ja: "タイ・リーグ1", es: "Thai League 1", fr: "Thai League 1" } },
  { league_id: 114, names: { en: "A-League", ko: "호주 A리그", ja: "Aリーグ", es: "A-League", fr: "A-League" } },
  { league_id: 17, names: { en: "AFC Champions League", ko: "AFC 챔피언스리그", ja: "AFCチャンピオンズリーグ", es: "Liga de Campeones AFC", fr: "Ligue des champions AFC" } },
  { league_id: 18, names: { en: "AFC Cup", ko: "AFC 컵", ja: "AFCカップ", es: "Copa de la AFC", fr: "Coupe de l'AFC" } },

  // ===== International =====
  { league_id: 1, names: { en: "World Cup", ko: "월드컵", ja: "ワールドカップ", es: "Copa Mundial", fr: "Coupe du monde" } },
  { league_id: 4, names: { en: "UEFA European Championship", ko: "유럽 선수권", ja: "UEFA欧州選手権", es: "Eurocopa", fr: "Championnat d'Europe" } },
  { league_id: 9, names: { en: "Copa América", ko: "코파 아메리카", ja: "コパ・アメリカ", es: "Copa América", fr: "Copa América" } },
  { league_id: 10, names: { en: "Friendlies", ko: "친선 경기", ja: "親善試合", es: "Amistosos", fr: "Matchs amicaux" } },
  { league_id: 15, names: { en: "Africa Cup of Nations", ko: "아프리카 네이션스컵", ja: "アフリカネーションズカップ", es: "Copa Africana de Naciones", fr: "CAN" } },
  { league_id: 6, names: { en: "FIFA Club World Cup", ko: "클럽 월드컵", ja: "クラブワールドカップ", es: "Mundial de Clubes", fr: "Coupe du monde des clubs" } },

  // ===== Domestic Cups (Europe) =====
  { league_id: 45, names: { en: "FA Cup", ko: "FA컵", ja: "FAカップ", es: "FA Cup", fr: "FA Cup" } },
  { league_id: 48, names: { en: "EFL Cup", ko: "EFL컵", ja: "EFLカップ", es: "EFL Cup", fr: "EFL Cup" } },
  { league_id: 81, names: { en: "DFB Pokal", ko: "DFB 포칼", ja: "DFBポカール", es: "DFB-Pokal", fr: "Coupe d'Allemagne" } },
  { league_id: 143, names: { en: "Copa del Rey", ko: "코파 델 레이", ja: "コパ・델・レイ", es: "Copa del Rey", fr: "Coupe du Roi" } },
  { league_id: 137, names: { en: "Coppa Italia", ko: "코파 이탈리아", ja: "コッパ・イタリア", es: "Copa Italia", fr: "Coupe d’Italie" } },
  { league_id: 66, names: { en: "Coupe de France", ko: "쿠프 드 프랑스", ja: "クープ・ドゥ・フランス", es: "Copa de Francia", fr: "Coupe de France" } },

  // ===== Americas (Legacy / Alternate IDs) =====
  { league_id: 262, names: { en: "Liga MX", ko: "리가 MX", ja: "リーガMX", es: "Liga MX", fr: "Liga MX" } },
  { league_id: 144, names: { en: "Chilean Primera División", ko: "칠레 프리메라", ja: "チリ 1부", es: "Primera División de Chile", fr: "Primera División chilienne" } },

  // ===== Middle East (Legacy ID) =====
  { league_id: 307, names: { en: "Saudi Pro League", ko: "사우디 프로리그", ja: "サウジ・プロリーグ", es: "Saudi Pro League", fr: "Saudi Pro League" } },
  { league_id: 308, names: { en: "Division 1", ko: "사우디 1부 리그", ja: "サウジ・ディビジョン1", es: "División 1 de Arabia Saudita", fr: "Division 1 saoudienne" } },

  // ===== Others (England / Spain Women) =====
  { league_id: 41, names: { en: "League One", ko: "잉글랜드 리그 1", ja: "リーグ1", es: "League One", fr: "League One" } },
  { league_id: 42, names: { en: "League Two", ko: "잉글랜드 리그 2", ja: "リーグ2", es: "League Two", fr: "League Two" } },
  { league_id: 44, names: { en: "FA WSL", ko: "잉글랜드 여자 슈퍼리그", ja: "FA女子スーパーリーグ", es: "FA WSL", fr: "FA WSL" } },
  { league_id: 142, names: { en: "Primera División Femenina", ko: "스페인 여자 리가 F", ja: "プリメーラ・ディビシオン・フェミニーナ", es: "Liga F", fr: "Primera División Femenina" } }
];

/**
 * Get translated league name by league ID and language
 */
export const getLeagueName = (leagueId: number, lang: Language, fallbackName?: string): string => {
  const translation = LEAGUE_TRANSLATIONS.find((l) => l.league_id === leagueId);
  if (!translation) return fallbackName || "Unknown League";
  return translation.names[lang] || translation.names.en || fallbackName || "Unknown League";
};

/**
 * Try to resolve a league name by matching any known translation value.
 * This helps when there is no league ID but we have an English or localized name.
 */
export const getLeagueNameFromAny = (name: string | undefined, lang: Language, fallbackName?: string): string => {
  if (!name) return fallbackName || 'Unknown League';
  const normalized = name.trim().toLowerCase();
  const found = LEAGUE_TRANSLATIONS.find(l => {
    return Object.values(l.names).some(n => (n || '').toLowerCase() === normalized);
  });
  if (found) return found.names[lang] || found.names.en || fallbackName || 'Unknown League';
  return fallbackName || name;
};

/**
 * Get league policy by league ID
 */
export const getLeaguePolicy = (leagueId: number): LeaguePolicy | null => {
  return LEAGUE_POLICIES.find(p => p.league_id === leagueId) || null;
};
